import { Injectable } from '@angular/core';
import {ServiceModule} from "../../../service.module";

@Injectable({
    providedIn: ServiceModule
})
export class SessionStorageService {
    getSessionStorage(): Storage {
        return sessionStorage;
    }

    set(key: string, data: string): void {
        this.getSessionStorage().setItem(key, data);
    }

    get(key: string): string | null {
        return this.getSessionStorage().getItem(key);
    }

    remove(key: string): void {
        this.getSessionStorage().removeItem(key);
    }
}
